//
//
//
//
//
//
//
//

import common from './common.vue';

export default {
  name: 'triple-bounce',

  mixins: [common],

  computed: {
    spinnerSize() {
      return ((this.size || this.$parent.size || 28) / 3) + 'px';
    },

    bounceStyle() {
      return {
        width: this.spinnerSize,
        height: this.spinnerSize,
        backgroundColor: this.spinnerColor
      };
    }
  }
};



// WEBPACK FOOTER //
// ./packages/spinner/src/spinner/triple-bounce.vue